<script lang="ts">
import { defineComponent, inject, ref } from "vue";
import ValidierungsFehler from "@/components/ValidierungsFehler.vue";
import formValidierung from "@/businesslogic/formValidierung";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "Maklerrabatt",
  components: { ValidierungsFehler },
  props: {
    fehler: Object,
  },
  setup() {
    const piniaStore = useFormStore();
    const istSichtbar: any = inject("istSichtbar");
    const wechsleSichtbarkeit: any = inject("wechsleSichtbarkeit");
    const fehlerKomponente = ref({} as any);
    const { erzwingeGanzzahl, berechneMaxRabatt } = formValidierung();

    return {
      piniaStore,
      istSichtbar,
      wechsleSichtbarkeit,
      fehlerKomponente,
      berechneMaxRabatt,
      erzwingeGanzzahl,
    };
  },
});
</script>

<template>
  <div class="o-grid o-grid--align-middle u-mar-t-2" v-if="berechneMaxRabatt(piniaStore.state) > 0">
    <div class="o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480 u-form-grid-nospace-y">
      <h2 class="u-form-heading unset-text-align">Maklerrabatt</h2>
    </div>

    <div
      class="o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 u-form-grid-nospace-y"
    >
      <div class="o-grid">
        <div class="o-grid__cell o-grid__cell--3-1024 o-grid__cell--3-480" style="margin-right: 0">
          <input
            type="number"
            @keydown="erzwingeGanzzahl"
            id="abschlagZuschlagHoehe"
            name="abschlagZuschlagHoehe"
            v-model.lazy.trim.number="piniaStore.state.tarifinformationen.abschlagZuschlagHoehe"
            class="c-form-control__input"
            min="0"
            max="99"
            placeholder="%"
            required
            aria-required="true"
            aria-label="Höhe des Maklerrabatts"
            data-cy="abschlagZuschlagHoehe"
          />
        </div>
      </div>
      <div class="o-grid o-grid--no-y-gutter o-grid--align-flex-end">
        <div class="o-grid__cell o-grid__cell--12">
          <validierungs-fehler :fehler-text="fehler.abschlagZuschlagHoehe" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
